document.addEventListener("DOMContentLoaded", async function () {
  const container = document.querySelector(".shipping-estimate");

  if (!container) {
    return;
  }

  const holidayUrl = container.dataset.holidayUrl; 
  const dateElements = container.querySelectorAll(".js-business-date");

  /**
   * Get "today" in Japan time.
   * Store it as a UTC date to avoid the influence of the viewer's time zone.
   */
  function getTodayInJapan() {
    const parts = new Intl.DateTimeFormat("ja-JP", {
      timeZone: "Asia/Tokyo",
      year: "numeric",
      month: "numeric",
      day: "numeric"
    }).formatToParts(new Date());

    const values = {};

    parts.forEach(function (part) {
      if (part.type !== "literal") {
        values[part.type] = Number(part.value);
      }
    });

    return new Date(
      Date.UTC(
        values.year,
        values.month - 1,
        values.day
      )
    );
  }

  /**
   * Converts to YYYY-MM-DD format.
   */
  function getDateKey(date) {
    const year = date.getUTCFullYear();
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const day = String(date.getUTCDate()).padStart(2, "0");

    return `${year}-${month}-${day}`;
  }

  /**
   * Determines whether the date is a Saturday, Sunday, or the JSON registration date.
   */
  function isClosedDay(date, closedDates) {
    const weekDay = date.getUTCDay();
    const dateKey = getDateKey(date);

    const isWeekend = weekDay === 0 || weekDay === 6;
    const isRegisteredHoliday = Boolean(closedDates[dateKey]);

    return isWeekend || isRegisteredHoliday;
  }

  /**
   * Calculates a date after a specified business day.
   * The count begins the day after the day in question; that day itself is not included.
   */
  function addBusinessDays(numberOfDays, closedDates) {
    const date = getTodayInJapan();
    let remainingDays = numberOfDays;

    while (remainingDays > 0) {
      date.setUTCDate(date.getUTCDate() + 1);

      if (!isClosedDay(date, closedDates)) {
        remainingDays--;
      }
    }

    return date;
  }

  /**
   * Converting for display.
   */
  function formatDate(date) {
    return `<span>${date.getUTCMonth() + 1}</span>月<span>${date.getUTCDate()}</span>日ごろ`;
  }

  try {
    const response = await fetch(holidayUrl, {
      mode: "cors",
      credentials: "same-origin"
    });

    if (!response.ok) {
      throw new Error(
        `Unable to retrieve business holidays data.：${response.status}`
      );
    }

    const closedDates = await response.json();

    dateElements.forEach(function (element) {
      const numberOfDays = Number(element.dataset.businessDays);

      if (!Number.isInteger(numberOfDays) || numberOfDays < 0) {
        element.textContent = "計算中....";
        return;
      }

      const calculatedDate = addBusinessDays(
        numberOfDays,
        closedDates
      );

      element.innerHTML = formatDate(calculatedDate);
    });
  } catch (error) {
    /*
     * To avoid displaying incorrect appointment dates,
     * Date calculation is not performed if JSON retrieval fails.
     */
    dateElements.forEach(function (element) {
      element.textContent = "Sorry, unable to calculate the date.";
    });
  }
});
